// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts

import { campaignDailyMetricsCubeMeta } from 'shared/src/generated/cube-meta/campaign-daily-metrics';
import { campaignsCubeMeta } from 'shared/src/generated/cube-meta/campaigns';
import { creativesCubeMeta } from 'shared/src/generated/cube-meta/creatives';
import { insertionOrdersCubeMeta } from 'shared/src/generated/cube-meta/insertion-orders';
import { lineItemMediaTradersCubeMeta } from 'shared/src/generated/cube-meta/line-item-media-traders';
import { lineItemMetricsDailyCubeMeta } from 'shared/src/generated/cube-meta/line-item-metrics-daily';
import { lineItemsCubeMeta } from 'shared/src/generated/cube-meta/line-items';
import { mediaBuyMetricsDailyCubeMeta } from 'shared/src/generated/cube-meta/media-buy-metrics-daily';
import { mediaBuysCubeMeta } from 'shared/src/generated/cube-meta/media-buys';
import { notesCubeMeta } from 'shared/src/generated/cube-meta/notes';
import { platformEntitiesCubeMeta } from 'shared/src/generated/cube-meta/platform-entities';
import { platformEntityChangesDailyCubeMeta } from 'shared/src/generated/cube-meta/platform-entity-changes-daily';
import { userActivityDailyCubeMeta } from 'shared/src/generated/cube-meta/user-activity-daily';
import { zohoAccountsCubeMeta } from 'shared/src/generated/cube-meta/zoho-accounts';
import { zohoLineItemsCubeMeta } from 'shared/src/generated/cube-meta/zoho-line-items';
import { zohosignDocumentsCubeMeta } from 'shared/src/generated/cube-meta/zohosign-documents';

import type { CubeMetaDefinition } from 'shared/src/api/cube-api-types';

export type CubeMetaCubeName =
  | 'campaign_daily_metrics'
  | 'campaigns'
  | 'creatives'
  | 'insertion_orders'
  | 'line_item_media_traders'
  | 'line_item_metrics_daily'
  | 'line_items'
  | 'media_buy_metrics_daily'
  | 'media_buys'
  | 'notes'
  | 'platform_entities'
  | 'platform_entity_changes_daily'
  | 'user_activity_daily'
  | 'zoho_accounts'
  | 'zoho_line_items'
  | 'zohosign_documents';

export const allCubeMeta: Record<CubeMetaCubeName, CubeMetaDefinition> = {
  campaign_daily_metrics: campaignDailyMetricsCubeMeta,
  campaigns: campaignsCubeMeta,
  creatives: creativesCubeMeta,
  insertion_orders: insertionOrdersCubeMeta,
  line_item_media_traders: lineItemMediaTradersCubeMeta,
  line_item_metrics_daily: lineItemMetricsDailyCubeMeta,
  line_items: lineItemsCubeMeta,
  media_buy_metrics_daily: mediaBuyMetricsDailyCubeMeta,
  media_buys: mediaBuysCubeMeta,
  notes: notesCubeMeta,
  platform_entities: platformEntitiesCubeMeta,
  platform_entity_changes_daily: platformEntityChangesDailyCubeMeta,
  user_activity_daily: userActivityDailyCubeMeta,
  zoho_accounts: zohoAccountsCubeMeta,
  zoho_line_items: zohoLineItemsCubeMeta,
  zohosign_documents: zohosignDocumentsCubeMeta
};
